<template>
  <tr>
    <td class="data__ip-name">
      <span v-if="!item.edit">{{ item.name }}</span>
      <div v-else class="input--wrap">
        <ui-input-text-bubble :isInputAbove="false"
                              :value="item.name"
                              :modelError="modelError.name"
                              :placeholder="''"
                              @onFocus="modelError.name = ''"
                              @input="getIpName"/>
      </div>
    </td>
    <td class="data__ip-address">
      <span v-if="!item.edit">{{ item.ip }}</span>
      <div v-else class="input--wrap">
        <ui-input-text-bubble :isInputAbove="false"
                              :value="item.ip"
                              :modelError="modelError.ip"
                              :placeholder="''"
                              @onFocus="modelError.ip = ''"
                              @input="getIp"/>
      </div>
    </td>
    <td class="data__function">
      <div v-if="!item.edit" class="no-edit">
        <ui-button class="btn__edit circle"
                   size="small"
                   :hideLabel="true"
                   :iconName="'icon--pencil'"
                   :noBorder="true"
                   @click="onEditMode(item)"></ui-button>
        <ui-button class="btn__delete circle"
                   size="small"
                   :hideLabel="true"
                   :iconName="'icon--trash'"
                   :noBorder="true"
                   @click="onRemoveListItem(item)"></ui-button>
      </div>
      <div v-else>
        <ui-button class="btn__edit-cancel circle"
                   size="small"
                   :hideLabel="true"
                   :iconName="'icon--close-size16'"
                   @click="onCancelEditMode(item)"></ui-button>
        <ui-button class="btn__confirm circle"
                   size="small"
                   :hideLabel="true"
                   :iconName="'icon--check-green-size16'"
                   @click="onEditListItem(item)"></ui-button>
      </div>
    </td>
  </tr>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiInputTextBubble from '@/components/ui/UiInputTextBubble'
import { isValidIpAddress } from '@/libs/validation-helper'

export default {
  components: {
    UiButton,
    UiInputTextBubble
  },
  props: [
    'item',
    'ipList'
  ],
  data () {
    return {
      model: {
        name: this.item.name,
        ip: this.item.ip
      },
      modelError: {
        name: '',
        ip: ''
      }
    }
  },
  methods: {
    getIpName (value) {
      this.model.name = value
    },
    getIp (value) {
      this.model.ip = value
    },
    onEditMode (item) {
      item.edit = true
      this.model.name = this.item.name
      this.model.ip = this.item.ip
    },
    onRemoveListItem (item) {
      this.$emit('removeListItem', item)
    },
    onCancelEditMode (item) {
      this.modelError.name = ''
      this.modelError.ip = ''
      item.edit = false
    },
    onEditListItem (item) {
      if (!this.model.name) {
        this.modelError.name = 'ipBlock.requiredIpName'
      }
      if (!this.model.ip) {
        this.modelError.ip = 'ipBlock.requiredIpAddress'
      }
      if (this.ipList) {
        this.ipList.forEach(listItem => {
          if (this.model.name && listItem.name === this.model.name && (this.model.name !== item.name)) {
            this.modelError.name = 'ipBlock.existName'
          }
          if (this.model.ip && listItem.ip === this.model.ip && (this.model.ip !== item.ip)) {
            this.modelError.ip = 'ipBlock.existIp'
          }
        })
      }

      if (!this.modelError.ip && !isValidIpAddress(this.model.ip)) {
        this.modelError.ip = 'ipBlock.diffFormat'
      }

      if (this.modelError.name || this.modelError.ip) return false

      this.$emit('editListItem', { item: item, model: this.model })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
tr {
  height: 50px;
  border-bottom: 1px solid #ebebeb;
  box-sizing: border-box;

  &.no-ip-list {
    text-align: center;
  }

  td {
    font-size: 13px;
    line-height: 1.23;
    color: #2f2f2f;

    .input--wrap {
      position: relative;
      display: inline-block;

      input[type=text] {
        width: 157px;
        margin-top: 0;
      }
    }

    &.data__ip-name {
      padding-left: 10px;
    }

    &.data__ip-address {
      text-align: center;
    }

    &.data__function {
      text-align: right;

        /deep/ .ui-btn {
        box-sizing: border-box;
        min-width: 0;
        width: 34px;
        height: 34px;

        &:nth-last-of-type(1) {
          margin-left: 5px;
        }

        .icon {
          @include positionXYcenter;
        }
      }
    }
  }
}
</style>
